import { GridPayload } from './../models/gridPayload.model';
import axiosInstance from './api/axios';
import {
	ADD_RECRUIT,
	ADD_UPDATE_RECRUIT_DETAILS,
	GET_DOWNLOAD_URL_BY_FIELD,
	GET_LOGGER_IN_MANAGER_ID,
	GET_RECRUITS,
} from './api/apiEndpoints';
import { ApiResponse } from '../models/apiResponse.model';
import { GridResponse } from '../models/gridResponse.model';
import { RecruitInfo } from '../models/recruitInfo.model';
import { EditRecruitModel } from '../models/editRecuitModel';

export const getAllRecruits = async (
	payload: GridPayload,
): Promise<ApiResponse<GridResponse> | undefined> => {
	const url = `${process.env.REACT_APP_API_BASE_URL}/${GET_RECRUITS}`;
	try {
		const response = await axiosInstance.post(url, payload);
		return response.data;
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
	} catch (error: any) {
		console.error(error);
	}
};

export const addNewRecruit = async (
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	payload: any,
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
): Promise<ApiResponse<any> | undefined> => {
	const url = `${process.env.REACT_APP_API_BASE_URL}/${ADD_RECRUIT}`;
	try {
		const response = await axiosInstance.post(url, payload);
		return response.data;
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
	} catch (error: any) {
		console.error(error);
		throw error;
	}
};
export const addUpdatedRecruit = async (
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	payload: EditRecruitModel,
): Promise<ApiResponse<RecruitInfo> | undefined> => {
	const url = `${process.env.REACT_APP_API_BASE_URL}/${ADD_UPDATE_RECRUIT_DETAILS}`;
	try {
		const response = await axiosInstance.post(url, payload);
		return response.data;
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
	} catch (error: any) {
		console.error(error);
		throw error;
	}
};

export const getDownloadURLByField = async (
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	{ recruitId, fileId }: { recruitId: string; fileId: string },
): Promise<ApiResponse<string> | undefined> => {
	const url = `${process.env.REACT_APP_API_BASE_URL}/${GET_DOWNLOAD_URL_BY_FIELD}?recruitId=${recruitId}&fileId=${fileId}`;
	try {
		const response = await axiosInstance.get(url);
		return response.data;
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
	} catch (error: any) {
		console.error(error);
		throw error;
	}
};

export const getLoggedInUserManagerId = async (
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	{ userEmail }: { userEmail: string },
): Promise<ApiResponse<string> | undefined> => {
	const url = `${process.env.REACT_APP_API_BASE_URL}/${GET_LOGGER_IN_MANAGER_ID}?userEmail=${userEmail}`;
	try {
		const response = await axiosInstance.get(url);
		return response.data;
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
	} catch (error: any) {
		console.error(error);
	}
};
